import {RouterProvider} from "react-router";
import {router} from "@components/default/Router.tsx";


export function AppRoutes() {
	return <RouterProvider router={router}/>;
}
